import PrizmdocViewer from '../src/utils/prizmdoc/viewer'
import API from '../src/vue_shared/api'

document.addEventListener('DOMContentLoaded', async () => {
  if (!document.querySelector('[data-prizmdoc-viewer]')) return

  const prizmdocViewer = await PrizmdocViewer(null)

  async function createPrizmdocViewer(el: HTMLElement): Promise<void> {
    const {
      returnUrl,
      documentId,
      documentUrl,
      documentFileExt,
      documentName,
      prettyId,
      redaction
    } = el.dataset

    // Get hybrid viewing setting from checkbox
    const hybridViewingCheckbox = document.getElementById(
      'enable-hybrid-viewing'
    ) as HTMLInputElement
    const enableHybridViewing = hybridViewingCheckbox?.checked || false

    const {
      data: { viewingSessionId }
    } = await API.newViewingSession(
      documentId,
      documentUrl,
      documentFileExt.slice(1),
      enableHybridViewing
    )

    // TODO: include more differences in arguments
    const redactionArgs = redaction
      ? {
          redactedDocumentName: `${documentName}-redacted.pdf`,
          redactedDocumentsPath: `/client/requests/${prettyId}/redacted_documents`
        }
      : {}
    await prizmdocViewer(
      `#${el.id}`,
      viewingSessionId,
      documentName,
      redaction,
      null,
      {
        rapidReview: false,
        prettyId,
        documentId,
        returnUrl,
        ...redactionArgs
      }
    )

    // Set the redactionComments option when finalizing to remove comments.
    window.PCCViewer.Ajax.setOverrideMethod((options) => {
      if (
        options.method === 'POST' &&
        options.url.match(/\/ViewingSession\/.*\/MarkupBurner/g)
      ) {
        if (options.url.match(/.*\/MarkupBurner$/g)) {
          options.url += '?'
        } else {
          options.url += '&'
        }

        options.url += 'redactionComments=removeHidden'
      }
    })
  }

  document
    .querySelectorAll('[data-prizmdoc-viewer]')
    .forEach(createPrizmdocViewer)

  // Add event listener for hybrid viewing checkbox
  const hybridViewingCheckbox = document.getElementById(
    'enable-hybrid-viewing'
  ) as HTMLInputElement
  if (hybridViewingCheckbox) {
    hybridViewingCheckbox.addEventListener('change', () => {
      const viewerEl = document.querySelector(
        '[data-prizmdoc-viewer]'
      ) as HTMLElement
      if (viewerEl) {
        viewerEl.innerHTML = ''
        createPrizmdocViewer(viewerEl)
      }
    })
  }
})
